import { get } from 'lodash';
import { SensordataSTChartLine } from '../../monitoring.model';
import { CommanderMonitoringFilterLogicalObject } from './filter.model';

export function filterAnalogChannels(
  sensordataList: SensordataSTChartLine[] = [],
  filterObject: CommanderMonitoringFilterLogicalObject,
  cloudGeneratedFilterLogicalObject?: CommanderMonitoringFilterLogicalObject
): SensordataSTChartLine[] {
  return sensordataList.filter((sensordata) => {
    const isActive =
      get(filterObject, [
        sensordata.deviceId ?? '',
        sensordata.controlunit,
        sensordata.channel,
      ]) ||
      get(cloudGeneratedFilterLogicalObject, [
        sensordata.deviceId ?? '',
        sensordata.controlunit,
        sensordata.channel,
      ]);
    return isActive;
  });
}
